import { getJson, postJson } from './client'
import type { DealsView, DealView } from '../types/deals'
import type { LeadPageView } from '../types/leads'
import type { PipelineStats, PipelineTab } from '../types/pipeline'
import type { JobView } from '../types/voice'

// The pipeline surface: the leads and opportunities read out of the person's mail, and one lead opened
// (the pursuit, the account behind it, the callouts, the research note) with research as a job.
const deals = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/deals`
const leads = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/leads`

export const dealsApi = {
  list: (spoke: string, tab: 'leads' | 'opportunities' | 'delivery' | 'all') => getJson<DealsView>(deals(spoke), { tab }),
  get: (spoke: string, engagementId: string) => getJson<DealView>(`${deals(spoke)}/${encodeURIComponent(engagementId)}`),
  /** The analytics band: everything computed on the API, for the org the client's `org=` names. */
  stats: (spoke: string, tab: PipelineTab) => getJson<PipelineStats>(`${deals(spoke)}/stats`, { tab }),
  scan: (spoke: string, maxThreads?: number) => postJson<JobView>(`${deals(spoke)}/scan`, { maxThreads }),
  lead: (spoke: string, engagementId: string) => getJson<LeadPageView>(`${leads(spoke)}/${encodeURIComponent(engagementId)}`),
  research: (spoke: string, engagementId: string) => postJson<JobView>(`${leads(spoke)}/${encodeURIComponent(engagementId)}/research`),
}
